import React from 'react';
import {Formik, Field, Form} from 'formik';
import {TextField, Loading, MultiSelect, Select, PersianDataPicker, TextArea} from 'components/form';
import {required, validationWrapper, isUserName} from 'lib/formValidations';
import {transformTranslateFromValues, transformTranslateServerValues, dateTimeToserver} from 'lib/helpers';
import Modal from 'components/Modal';
import {useCore} from 'store/core';

export default function Edit(props) {
  const core = useCore();
  const {item} = props;

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{
            ...transformTranslateServerValues({
              ...item,
              roles: item?.roles ? item.roles.map((roleItem) => roleItem.id) : [],
            }),
          }}
          onSubmit={async (values, {setSubmitting}) => {
            if (values.birthday) {
              values.birthday = dateTimeToserver(values.birthday, 'YYYY-MM-DD');
            }
            await props.submit(transformTranslateFromValues(values), item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({isSubmitting, dirty, values}) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="first_name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field placeholder="نام (en)" label="نام (en):" name="_en*first_name*text" component={TextField} />

                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="last_name"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    placeholder="نام خانوادگی (en)"
                    label="نام خانوادگی (en) :"
                    name="_en*last_name*text"
                    component={TextField}
                  />

                  <Field
                    placeholder="نام کاربری"
                    label="نام کاربری :"
                    name="user_name"
                    component={TextField}
                    validate={isUserName}
                  />

                  <Field placeholder="آدرس و شماره تلفن" label="آدرس و شماره تلفن :" name="address" component={TextArea} />
                  <Field
                    placeholder="آدرس و شماره تلفن (en)"
                    label="آدرس و شماره تلفن (en) :"
                    name="_en*address*text"
                    component={TextArea}
                  />

                  <div className="user-datepicker">
                    <Field label="تاریخ تولد :" name="birthday" component={PersianDataPicker} />
                  </div>

                  <div>
                    <Field placeholder="کشور" label="کشور :" name="country_id" component={Select} options={core.countries || []} />
                  </div>

                  {core.rolesLoad ? (
                    <Loading />
                  ) : (
                    <Field label="نقش ها :" name="roles" valueOnly component={MultiSelect} options={core.roles || []} />
                  )}

                  {Array.isArray(values.roles) && values.roles.includes(23) && (
                    <>
                      {core.productCategoriesLoad ? (
                        <Loading />
                      ) : (
                        <Field
                          label="محصولات :"
                          name="reseller_categories"
                          valueOnly
                          component={MultiSelect}
                          options={core.productCategories || []}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="modal-footer text-right">
                <button className="btn btn-primary w-20" type="submit" disabled={!!(isSubmitting || !dirty)}>
                  {isSubmitting ? <Loading /> : 'ذخیره'}
                </button>
                <button type="button" disabled={isSubmitting} onClick={props.close} className="btn btn-outline-secondary w-20 mr-1">
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
